import { all } from "axios";
import { getCapitalise } from "../utils/utilityfunc";

// App version for deployment verification
export const APP_VERSION = "1.0.1";
export const DEPLOYED_AT = "2026-01-19T12:30:00Z";

export const PHONE_REGEX = /^[0-9]{10}$/;
export const INTEGER_REGEX = /^\d+$/;
export const P_INT_REGEX = /^[1-9]\d*$/;
export const HEIGHT_REGEX = /^(?:[0-9]|10|11)$/;

export const ACCOUNT_TYPES = {
  admin: "admin",
  gym: "gym",
  member: "member",
  trainer: "trainer",
  nutrition: "nutrition",
  staff: "staff",
  sales: "sales",
  sales_executive: "receptionist",
  cash_collector: "cash_collector",
  fitness_manager: "fitness_manager",
  sales_manager: "sales_manager",
  marketing: "marketing",
  cluster_manager: "cluster_manager",
};

export const ACCOUNT_OPT = Object?.entries(ACCOUNT_TYPES)?.map(([key, val]) => {
  return {
    label: getCapitalise(`${key}`?.replaceAll("_", " ")),
    value: val,
  };
});

export const momentDayMap = {
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
  7: "Sunday",
};

export const reverseMomentDayMap = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7,
};

export const statusMap = {
  active: "bg-success",
  inactive: "bg-danger",
  pending: "bg-warning",
};

export const FORGET_PASSWORD_STEPS = {
  EMAIL: 1,
  RESET: 2,
  COMPLETE: 3,
};

export const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = Math.abs(hash).toString(16).substring(0, 6);
  return `#${"0".repeat(6 - color.length)}${color}`;
};

export const NOTIFICATION_TYPE_MAP = {
  // whatsapp: "whatsapp",
  push: "push",
  sheduled: "scheduled",
};

export const NOTIFICATION_TYPE = Object.keys(NOTIFICATION_TYPE_MAP).map(
  (key) => {
    const val = NOTIFICATION_TYPE_MAP[key];
    return {
      label: getCapitalise(`${key}`?.replaceAll("_", " ")),
      value: val,
    };
  }
);

export const NOTIFICATION_ACCOUNT_TYPE = {
  all: "all",
  trainer: "trainer",
  member: "member",
};

export const NOTIFICATION_ACCOUNT_TYPE_OPTIONS = Object.keys(
  NOTIFICATION_ACCOUNT_TYPE
).map((key) => {
  const val = NOTIFICATION_ACCOUNT_TYPE[key];
  return {
    label: getCapitalise(`${key}`?.replaceAll("_", " ")),
    value: val,
  };
});
